import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setListingId } from '../store/actions/ui';
import DetailOffcanvas from './detail_offcanvas';

function MatchDetailModal({ listingId, setListingId }) {
  const src = listingId ? `/connect/listings/${listingId}` : null;

  const hide = () => {
    setListingId();
  };

  return <DetailOffcanvas src={src} onHide={hide} />;
}

const mapStateToProps = ({ ui }) => ({ listingId: ui.listingId });

MatchDetailModal.propTypes = {
  listingId: PropTypes.number,
  setListingId: PropTypes.func.isRequired
};

export default connect(mapStateToProps, { setListingId })(MatchDetailModal);
